import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  preventSubmitOnEnter(event) {
    if (event.key === "Enter" && event.target.tagName !== "TEXTAREA") {
      event.preventDefault()
    }
  }
}
